import {GET_HOME_BANNERS, GET_EXCLUSIVE_BADGE} from '../actions/web-config/type'

/**
 * `exclusiveBadgeUrl: null` is the correct resting state, not an "unknown" placeholder:
 * null means "render the asset bundled in the build", which is what every render site
 * does with `badgeUrl || exclusiveImg`. It is also what a 404, a 500, a 503, a timeout,
 * a malformed body and a cleared setting all resolve to, so there is exactly one
 * fallback path (item 30, design.md decision 5).
 */
const initState = {homeBanners: null, exclusiveBadgeUrl: null}

/**
 * Reducer for the `webConfig` domain (registered as `webConfigReducer`,
 * `src/reducers/index.js:30`).
 *
 * @param {{homeBanners: *, exclusiveBadgeUrl: string|null}} [state=initState] — current slice.
 * @param {{type: string, payload: *}} action — `GET_HOME_BANNERS` or `GET_EXCLUSIVE_BADGE`.
 * @returns {{homeBanners: *, exclusiveBadgeUrl: string|null}} the next slice. Never throws:
 *   a non-string `GET_EXCLUSIVE_BADGE` payload becomes `null`, which every render site
 *   reads as "use the bundled asset".
 */
export default function(state = initState, action) {
    switch(action.type) {
        case GET_HOME_BANNERS: 
            return {...state, homeBanners: action.payload}
        case GET_EXCLUSIVE_BADGE:
            // Coerced rather than trusted: the reducer is the last place a non-string
            // can be stopped before it reaches an <img src>.
            return {...state, exclusiveBadgeUrl: typeof action.payload === 'string' && action.payload ? action.payload : null}
        default:
            return {...state}
    }
}
